export interface IndexDto {
	entities: EntityDto[]
}
export interface EntityDto {
	key: string,
	links: string[] | undefined,
	depiction: EntityDataDto<string> | undefined,
	alias: EntityDataDto<string[]> | undefined,
	connections: EntityDataDto<string[]> | undefined,
	tags: EntityDataDto<string[]> | undefined
}

export interface EntityDataDto<T> {
	[episodeId: string]: T
}